import { render } from "./SearchingComplaining.vue?vue&type=template&id=2e68d388&scoped=true"
import script from "./SearchingComplaining.vue?vue&type=script&lang=js"
export * from "./SearchingComplaining.vue?vue&type=script&lang=js"

import "./SearchingComplaining.vue?vue&type=style&index=0&id=2e68d388&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e68d388"]])

export default __exports__